// Slugs de primer nivel que ya usa la app: una página de registro no puede
// pisarlos (React Router le daría prioridad a la ruta explícita y la página
// configurada nunca se vería).
export const RUTAS_RESERVADAS = [
  'login', 'register', 'contenidos', 'documentos', 'courses', 'lessons', 'progress',
  'dashboard', 'perfil', 'certificados', 'verificar', 'analytics', 'evaluations',
  'evaluacion', 'consulta', 'consultaiphone', 'mentor', 'reto', 'admin', 'admin-panel',
  'sso', 'voice-test', 'test-voice-iphone', 'wa-training', 'p',
];

/** Normaliza lo que escribe el admin a un slug de URL usable. */
export const normalizarSlugRuta = (valor) =>
  (valor || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/^\/+|\/+$/g, '')
    .replace(/[^a-z0-9\-_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

/** true si el slug sirve como ruta propia (no vacío y no reservado). */
export const slugRutaValido = (valor) => {
  const s = normalizarSlugRuta(valor);
  return !!s && !RUTAS_RESERVADAS.includes(s);
};
